function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { XS } from "constants/sizes";
import Colors from "styles/colors";
import { useMemo } from "react";
import CheckboxSVG from "../../checkbox-icon";
import { StyledProductCardUseCases } from "./product-card-use-cases.scss";
import SelectableTagsGrid from "../../../selectable-tags-grid/selectable-tags-grid";
import ProductSignUp from "../../../product-sign-up/product-sign-up";
import classNames from "classnames";
import { WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
const ProductCardUseCases = ({ useCases, productColor, isUseCasesReadonly, productType, showUseCasesVertically })=>{
    const buttonConfig = useMemo(()=>({
            useCtaIcon: true,
            buttonSize: XS,
            buttonColor: productColor,
            productIdToUse: productType,
            skipUpdateCluster: true,
            extraData: {
                selectedProduct: productType
            }
        }), [
        productColor,
        productType
    ]);
    const gridSelectableTags = useMemo(()=>useCases === null || useCases === void 0 ? void 0 : useCases.map((_param)=>{
            var { useCase } = _param, rest = _object_without_properties(_param, [
                "useCase"
            ]);
            return _object_spread({
                tagText: useCase
            }, rest);
        }), [
        useCases
    ]);
    return /*#__PURE__*/ _jsxs(StyledProductCardUseCases, {
        className: "product-card-use-cases",
        style: {
            "--color": Colors[productColor]
        },
        children: [
            isUseCasesReadonly ? /*#__PURE__*/ _jsx("div", {
                className: "readonly-use-cases-wrapper",
                style: {
                    "flex-direction": showUseCasesVertically ? "column" : "row"
                },
                children: useCases === null || useCases === void 0 ? void 0 : useCases.map(({ useCase })=>/*#__PURE__*/ _jsxs("div", {
                        className: classNames("readonly-use-case", {
                            "work-management": productType === WORK_MANAGEMENT_PRODUCT_ID
                        }),
                        children: [
                            /*#__PURE__*/ _jsx(CheckboxSVG, {}),
                            useCase
                        ]
                    }))
            }) : /*#__PURE__*/ _jsx(SelectableTagsGrid, {
                buttonTopMargin: "0",
                disableAnimation: true,
                buttonConfig: buttonConfig,
                gridSelectableTags: gridSelectableTags
            }),
            isUseCasesReadonly && /*#__PURE__*/ _jsx(ProductSignUp, {
                useCtaIcon: true,
                buttonSize: XS,
                buttonColor: productColor,
                productType: productType
            })
        ]
    });
};
export default ProductCardUseCases;
